import Technicians from "@/pages/technicians/technicians.vue";

export const routes = {
    Login: 'login',
    Logout: 'logout',
    Products: 'spdProducts',
    ProductStatusUpdate: 'spdProducts/updateStatus',
    UpdateProductStock: 'spdProducts/updateProductStock',
    AddProduct: 'spdProducts/create',
    UpdateProduct: 'spdProducts/update',
    ProductDetail: 'spdProducts/details',
    StockLogs: 'spdProducts/stockLogs',
    Settings: 'settings',
    AdminProfile: 'settings/detailsUpdate',
    AdminPassword: 'settings/passwordUpdate',
    AdminSpecialIncentive: 'settings/otherDetailsUpdate',
    Dashboard: 'dashboard',
    Technicians: 'technicians',
    UpdateTechnicianStatus: 'technicians/updateStatus',
    DeleteTechnician: 'technicians/destroy',
    TechnincianDetails: 'technicians/details',
    TechnicianWorks: 'technicians/works',
    TechnicianProducts: 'technicians/technician_products',
    UpdateTechnicianProductStock: 'technicians/updateProduct',
    TechnicianStockLogs: 'technicians/technician_product_logs',
    TechnicianRemainingProducts: 'technicians/technician_remaining_products',
    AddTechnicianProduct: 'technicians/addProduct',
    AllProducts: 'spdProducts/all_products',
    AddTechnician: 'technician/add',
    UpdateTechnician: 'technician/update',
    TechnicianTravelLogs: 'technician/locationLog',
    Jobs: 'works',
    JobDetail: 'workDetails',
    AllTechnicians: 'technicians/all_technicians',
    AllDevices: 'all_devices',
    AddWork: 'createWork',
    VehicleTypes: 'vehicle_types',
    UpdateWork: 'updateWork',
    WorkRequests: 'work_requests',
    AcceptWork: 'accept_work',
    ProductStockReport: 'productStockReport',
    EarningReport: 'earningReport',
    WorkReport: 'workReport',
    WorkReportPdf: 'workReportDownload',
    ProductStockReportPdf: 'productStockReportDownload',
    EarningReportPdf: 'earningReportDownload',
    WorkReportExcel: 'workReportExcel',
    EarningReportExcel: 'earningReportExcel',
    ProductStockReportExcel: 'productStockReportExcel',
    CancelledRequests: 'cancellationRequests',
    CancelJob: 'acceptCancelRequest',
    ReAssignJob: 'reassignJob',
    TechnicianReport: 'technicianReport',    
    TechnicianReportExcel: 'technicianReportExcel',
    TechnicianReportDownload: 'technicianReportDownload',
    DeviceWorkLogs: 'device_work_logs',
    EnquiryList: 'enquiryJobs',
    EnquiryDetail: 'enquiryJobDetails',
    EnquiryFollowUp: 'enquiryJobFollowUp',
    EnquiryCancel: 'enquiryJobCancel',
    UpdatePayment: 'updatePayment',
    MarkAsDone: 'markAsDone',
    RTOList: 'rtoList',
    CompanyTitles: 'spdCompanyTitles',
    addCompanyTitle: 'addCompanyTitle',
    getSpdCompanyTitles: 'getSpdCompanyTitles',
    SpeedGoverners: 'speedGovernors',
    uploadSpeedGovernorData: 'uploadSpeedGovernorData',
    getSpeedGovernorData: 'getSpeedGovernorData',
    speedGovernorDetails: 'speedGovernorDetails',
    completeJobData: 'completeJobData',
    companyTitleDetails: 'detailsCompanyTitle',
    updateCompanyTitle: 'updateCompanyTitle',
    searchJobData: 'searchJobData',
    InstallationCertificate: 'generateWorkCertificate',
    Staffs: 'staffs',
    AddStaff: 'addStaff',
    UpdateStaff: 'updateStaff',
    StaffDetails: 'staffDetails',
    UpdateStaffStatus: 'updateStaffStatus',
    JobLogs: 'workLogs',
    DeleteJob: 'destroyWork',
    getDealers: 'getDealers',
    assignSpdDeviceToDealer: 'assignSpdDeviceToDealer',
};